import { Colors } from "./components/colors/colors";
import { Families } from "./components/families/families";
import { Finishes } from "./components/finishes/finishes";
import { Navigation } from "./components/navigation/navigation";
import { Products } from "./components/products/products";
import { Step } from "./components/step/step";
import { Steps } from "./components/steps/steps";
import { Volumes } from "./components/volumes/volumes";
import { Base } from "./paintConfigurator.base";

export const PaintConfigurator = Object.assign(Base, {
    Families,
    Steps,
    Step,
    Navigation,
    Colors,
    Finishes,
    Volumes,
    Products
});
